import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-checklist-single"
}
const _hoisted_2 = { class: "my-checklist-single-top" }
const _hoisted_3 = { class: "my-checklist-single-icon" }
const _hoisted_4 = ["title", "onClick"]
const _hoisted_5 = { class: "role-banner-left" }
const _hoisted_6 = { class: "role-banner-info" }
const _hoisted_7 = { class: "role-banner-title" }
const _hoisted_8 = { class: "role-banner-meta" }
const _hoisted_9 = { class: "role-banner-loc" }
const _hoisted_10 = {
  key: 2,
  class: "my-checklists"
}
const _hoisted_11 = { class: "my-checklists-list" }
const _hoisted_12 = ["title", "onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_my_numbers = _resolveComponent("my-numbers")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$store.state.user.teamHubChecklists && _ctx.$store.state.user.companyID == 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_svg_icon, { icon: "checklist" })
            ]),
            _createElementVNode("div", null, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "my-checklist-single-text" }, "The most experienced airline captain alive still runs the checklist before every takeoff — not because he forgot how to fly, but because fatigue, stress, and one badly-timed interruption don't care how good you are. The checklist doesn't slow the expert down. It frees them up — so when your attention gets hijacked, the one step you'd have missed is already caught, and your focus stays on the work that matters.", -1)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.teamHubChecklists, (c, i) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: i,
                  title: c.Name,
                  onClick: _withModifiers(($event: any) => (_ctx.openChecklist(c)), ["prevent"]),
                  type: "button",
                  class: "btn my-checklist-single-btn"
                }, _toDisplayString(c.Name), 9, _hoisted_4))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.roleLabel)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "role-banner",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showRole()))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "role-banner-icon" }, [
              _createElementVNode("svg", {
                viewBox: "0 0 24 24",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                _createElementVNode("path", { d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" })
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_6, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "role-banner-eyebrow" }, "Your Assigned Role", -1)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.roleLabel), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$store.state.user.teamHubEmployee.Location), 1)
              ])
            ])
          ]),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "role-banner-action" }, "View role sheet", -1))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_my_numbers),
    (_ctx.$store.state.user.teamHubChecklists && _ctx.$store.state.user.teamHubChecklists.length && _ctx.$store.state.user.companyID != 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "my-checklists-label" }, "My Powerlists", -1)),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.user.teamHubChecklists, (c, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                title: c.Name,
                onClick: _withModifiers(($event: any) => (_ctx.openChecklist(c)), ["prevent"]),
                class: "my-checklist-link"
              }, [
                _createVNode(_component_svg_icon, { icon: "checklist" }),
                _createElementVNode("span", null, _toDisplayString(c.Name), 1)
              ], 8, _hoisted_12))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}